import { render } from "./NoKyc.vue?vue&type=template&id=6e8745dc&scoped=true"
import script from "./NoKyc.vue?vue&type=script&lang=js"
export * from "./NoKyc.vue?vue&type=script&lang=js"

import "./NoKyc.vue?vue&type=style&index=0&id=6e8745dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8745dc"]])

export default __exports__